import { message } from '@ezviz/ezd'
export default function copyToClipboard(text) {
    try {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        message.success("复制成功")
    } catch (error) {
        message.error("复制失败")
    }
}